import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SesionFacade } from '@core/store/sesion/sesion.facade';
import { requiereSesion, RUTAS_ONBOARDING } from '@core/constants/rutas.constants';

export const sesionResolver: ResolveFn<string | null> = (route: ActivatedRouteSnapshot): Observable<string | null> => {
  const rutaActual = '/' + route.url.map((s) => s.path).join('/');

  if (!requiereSesion(rutaActual)) {
    return of(null);
  }

  if (isPlatformServer(inject(PLATFORM_ID))) {
    return inject(SesionFacade).ensureSessionId();
  }

  const router = inject(Router);
  return inject(SesionFacade)
    .ensureSessionId()
    .pipe(
      tap((sessionId) => {
        if (sessionId === null) {
          void router.navigate([RUTAS_ONBOARDING.BIENVENIDA]);
        }
      }),
    );
};
